export default "__VITE_ASSET__CBn_Tai5__"